import {createApp} from "vue"

import App from "./App.vue"
import router from "./router"
import {createI18n} from "vue-i18n"
import {messages} from "./translations/messages"
import Api from "xpark-shared/services/api"
import AdminApi from "xpark-shared/services/admin-api"
import SettingsHelper from "./utils/SettingsHelper"
import Bugsnag from "@bugsnag/js"
import BugsnagPluginVue from "@bugsnag/plugin-vue"

Bugsnag.start({
    apiKey: "da82d54c8864a90b35ea20e51e5dce13",
    plugins: [new BugsnagPluginVue()]
})
const bugsnagVue = Bugsnag.getPlugin("vue") as any

const locales = SettingsHelper.getParkLlocales()
const i18n = createI18n({
    locale: locales && locales.length > 0 ? locales[0] : "fr",
    messages
})

const settings = (window as any)._settings
const currentUrl = window.location.hostname
const backendUrl = `http://${currentUrl}:${settings.backdEndPort}`
Api.init(backendUrl)
AdminApi.init(backendUrl)

SettingsHelper.init()

createApp(App)
    .use(router)
    .use(i18n)
    .use(bugsnagVue)
    .mount("#app")
